<div class="row" style="margin-top: 100px;">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header card-header-icon card-header-rose">
                <h3><i class="far fa-id-badge"></i> Leads <span class="badge badge-pill badge-success ml-1" style="font-size: larger;">{{ intCount }}</span></h3>
            </div>
            <div class="card-body">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="tableHeader">Name</th>
                            <th class="tableHeader">Email</th>
                            <th class="tableHeader">Company</th>
                            <th class="tableHeader">Position</th>
                            <th class="tableHeader">Date Submitted</th>
                            <th class="tableHeader text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let l of leads">
                            <td>{{ l.payload.doc.data().lastName }} , {{ l.payload.doc.data().firstName }}</td>
                            <td>{{ l.payload.doc.data().email  }}</td>
                            <td>{{ l.payload.doc.data().company }}</td>
                            <td>{{ l.payload.doc.data().jobTitle }}</td>
                            <td>{{ l.payload.doc.data().dateSubmitted | date: 'MM/dd/yyyy' }}</td>
                            <td class="td-actions text-right">
                                <button type="button" rel="tooltip" (click)="edit(l.payload.doc.id)" title="Edit" class="btn btn-success btn-lg mr-4">
                                    <i class="fas fa-edit" style="font-size: larger;"></i>
                                </button>
                                <button type="button" rel="tooltip" (click)="delete(l.payload.doc.id)" title="Delete" class="btn btn-danger btn-lg">
                                    <i class="fas fa-trash" style="font-size: larger;"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
    